


































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { storeHasilPenunjang } from "@/store/modules/HasilPenunjang";

@Component({
  components: {}
})
export default class TableHasilRadiologiForResume extends Vue {
  @Prop() selectedId;
  @Prop() register;
  @Prop({ default: false, type: Boolean }) showSelect: boolean;
  @Prop({ default: false, type: Boolean }) showActions: boolean;
  @Prop({ default: false, type: Boolean }) showReload: boolean;
  @Prop({ default: "asc", type: Boolean }) sort: "asc" | "desc";

  tblHeight = "500";
  headers = [
    {
      text: "Tgl Hasil",
      align: "start",
      value: "reportDate"
    },
    { text: "Pemeriksan", value: "nama" },
    { text: "Unit", value: "unit.nama" },
    { text: "Hasil", value: "description" }
  ];

  selectedItem = [];

  @Watch("selectedItem")
  changedselectedItem(val) {
    this.$emit("selectedItem", val);
  }

  @Watch("selectedId")
  changedSelectedId(val) {
    const ids = Array.isArray(val) ? val : [val];
    this.selectedItem = this.renderedResultList.filter(item =>
      ids.includes(item.acc_number)
    );
  }

  mounted() {}

  @Watch("showActions")
  changedShowActions(val) {
    if (val) {
      this.headers.push({ text: "Aksi", value: "id" });
    } else {
      this.headers.splice(
        this.headers.findIndex(item => item.text == "Aksi"),
        1
      );
    }
  }

  get rawResultListDummy() {
    return [
      {
        no_transaksi: "2099",
        tgl: "2023-10-10",
        dr_pengirim: "Dhani Indarto, dr.",
        dr_radiologi: "Rofi Siswanto, dr.,M.Sc,Sp.Rad",
        unit: {
          kode: "01",
          nama: "IGD"
        },
        hasil: [
          {
            kode: "RC025",
            nama: "PELVIS AP DEWASA",
            acc_number: "2310222099RC025",
            description:
              "Fraktur lama collum femur dextra,aposisi dan alignment kurang\nFrakur competa  proximal femur sinistra,aposisi dan alignment kurang\nGambaran coxitis sinistra",
            reportDate: "2023-10-10 22:07:25",
            dokter: "Rofi Siswanto, dr.,M.Sc,Sp.Rad",
            link:
              "https://192.168.50.27/portal/?user_name=hisris&password_encrypted=true&password=KGJGBCHIEJJDPCNCJGKEINFHNMHBKAOO&accession_number=2310222099RC025"
          }
        ]
      },
      {
        no_transaksi: "2100",
        tgl: "2023-10-10",
        dr_pengirim: "Dhani Indarto, dr.",
        dr_radiologi: "Rofi Siswanto, dr.,M.Sc,Sp.Rad",
        unit: {
          kode: "01",
          nama: "IGD"
        },
        hasil: [
          {
            kode: "70700",
            nama: "Femur AP/ Lateral Sinistra",
            acc_number: "231022210070700",
            description:
              "Klinis : post trauma\nFRaktur completa femur sinistra 1/3 proximal,aposisi dan alignment kurang",
            reportDate: "2023-10-10 22:08:12",
            dokter: "Rofi Siswanto, dr.,M.Sc,Sp.Rad",
            link:
              "https://192.168.50.27/portal/?user_name=hisris&password_encrypted=true&password=KGJGBCHIEJJDPCNCJGKEINFHNMHBKAOO&accession_number=231022210070700"
          },
          {
            kode: "RC001",
            nama: "THORAX    PA DEWASA",
            acc_number: "2310222100RC001",
            description: "Pulmo tak tampak kelainan\nBesar cor normal",
            reportDate: "2023-10-10 22:11:00",
            dokter: "Rofi Siswanto, dr.,M.Sc,Sp.Rad",
            link:
              "https://192.168.50.27/portal/?user_name=hisris&password_encrypted=true&password=KGJGBCHIEJJDPCNCJGKEINFHNMHBKAOO&accession_number=2310222100RC001"
          }
        ]
      }
    ];
  }

  get resultList(): Array<{
    kode: string;
    nama: string;
    acc_number: string;
    description: string;
    reportDate: string;
    unit: {
      id: string;
      nama: string;
    };
    dokter: string;
    link: string;
  }> {
    return storeHasilPenunjang.listHasilRadiologi.reduce((res, curr) => {
      // return this.rawResultListDummy.reduce((res, curr) => {
      res.push(
        ...curr.hasil.map(item => {
          item["unit"] = curr.unit;
          return item;
        })
      );

      return res;
    }, []);
  }

  get renderedResultList() {
    return this.resultList.sort((a, b) => {
      return this.sort === "desc"
        ? new Date(b.reportDate).getTime() - new Date(a.reportDate).getTime()
        : new Date(a.reportDate).getTime() - new Date(b.reportDate).getTime();
    });

    // return this.resultList;
  }

  get loadingList() {
    return storeHasilPenunjang.loadingRadiologi;
  }

  edit(id) {
    this.$emit("edit", id);
  }

  remove(id) {
    this.$emit("remove", id);
  }

  reload() {
    storeHasilPenunjang.getRadiologiByRegister(this.register);
  }
}
